import { rdc, resto } from '@saucelabs/sl-util-axios';

type TestDetails = {
  id: string;
  name: string;
  passed?: boolean;
};

const updateVirtualJob = (
  currentUserId: string,
  testDetails: TestDetails,
): AsyncResponse<TestDetails> => {
  const { id, ...otherTestDetails } = testDetails;
  return resto.put(`/rest/v1/${currentUserId}/jobs/${id}`, otherTestDetails);
};

const updateRealDeviceJob = (
  testDetails: TestDetails,
): AsyncResponse<TestDetails> => {
  const { id, ...otherTestDetails } = testDetails;
  return rdc.put(`/jobs/${id}`, otherTestDetails);
};

export default {
  updateRealDeviceJob,
  updateVirtualJob,
};
